import React from "react";
export const Navigation = (props) => {
  const { logo } = "img/logo.jpg";
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header" style={{ display: 'flex', alignItems: 'center' }}>
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top" style={{ fontSize: '15px', display: 'flex', alignItems: 'center' }}>
            <img src="img/logo.jpg" alt="Logo" style={{ maxHeight: '60px', marginRight: '10px' }} />
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                Características
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Acerca de
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Servicios
              </a>
            </li>
            <li>
              <a href="#espectaculo" className="page-scroll">
                Producciones
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                GALERÍA
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contacto
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
